export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'aboc',
    name: 'ABOC',
  },
  {
    id: 'alaska',
    name: 'Alaska Airlines Mileage Plan™',
  },
  {
    id: 'alliant',
    name: 'Alliant Credit Union',
  },
  {
    id: 'ally',
    name: 'Ally',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'avant',
    name: 'Avant',
  },
  {
    id: 'axos',
    name: 'Axos Bank',
  },
  {
    id: 'bettermortgage',
    name: 'Better Mortgage',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'chasebank',
    name: 'Chase Bank',
  },
  {
    id: 'chasesapphirereserve',
    name: 'Chase Sapphire Reserve',
  },
  {
    id: 'cit',
    name: 'CIT Bank',
  },
  {
    id: 'citi',
    name: 'Citi',
  },
  {
    id: 'collegeave',
    name: 'College Ave',
  },
  {
    id: 'commonbond',
    name: 'CommonBond',
  },
  {
    id: 'deserveedu',
    name: 'Deserve Edu',
  },
  {
    id: 'discoverbank',
    name: 'Discover Bank',
  },
  {
    id: 'discovercards',
    name: 'Discover Cards',
  },
  {
    id: 'earnest',
    name: 'Earnest',
  },
  {
    id: 'facetwealth',
    name: 'Facet Wealth',
  },
  {
    id: 'fairway',
    name: 'Fairway',
  },
  {
    id: 'geico',
    name: 'GEICO',
  },
  {
    id: 'handrblock',
    name: 'H&R Block',
  },
  {
    id: 'interactivebrokerslite',
    name: 'Interactive Brokers Lite',
  },
  {
    id: 'interactivebrokerspro',
    name: 'Interactive Brokers Pro',
  },
  {
    id: 'lenderfi',
    name: 'LenderFi',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'marcus',
    name: 'Marcus by Goldman Sachs',
  },
  {
    id: 'marriott',
    name: 'Marriott Bonvoy™',
  },
  {
    id: 'nbkc',
    name: 'NBKC',
  },
  {
    id: 'penfedpowered',
    name: 'Penfed Powered by Purefy',
  },
  {
    id: 'pnc',
    name: 'PNC',
  },
  {
    id: 'sofiinvesting',
    name: 'SoFi Investing',
  },
  {
    id: 'sofiloans',
    name: 'SoFi Loans',
  },
  {
    id: 'tdameritrade',
    name: 'TD Ameritrade',
  },
  {
    id: 'united',
    name: 'United Explorer',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'veteransunited',
    name: 'Veterans United',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
];
